import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/components/WebView/icons/AskNicelyHome.svg'
import _imports_1 from '@/components/WebView/icons/BackLeftAction.svg'
import _imports_2 from '@/components/WebView/icons/AddNew.svg'


const _withScopeId = n => (_pushScopeId("data-v-29ba3741"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "AskNicely"
}, null, -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "back"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "scroll-container" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "Create a new suggestion"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SuggestionsSubNav = _resolveComponent("SuggestionsSubNav")!
  const _component_SuggestionsList = _resolveComponent("SuggestionsList")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_ScreenBottomButton = _resolveComponent("ScreenBottomButton")!
  const _component_WebViewScreen = _resolveComponent("WebViewScreen")!

  return (_openBlock(), _createBlock(_component_WebViewScreen, {
    title: "Suggestions",
    class: "list-container",
    "disable-when-offline": ""
  }, {
    "left-button": _withCtx(() => [
      (_ctx.embedded)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openDrawer && _ctx.openDrawer(...args)))
          }, _hoisted_2))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.router.back()))
          }, _hoisted_4))
    ]),
    "right-button": _withCtx(() => [
      (_ctx.embedded && !_ctx.offline)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_RouterLink, { to: { name: 'suggestionsCreate' } }, {
              default: _withCtx(() => [
                _hoisted_7
              ], undefined, true),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_SuggestionsSubNav, { "in-dashboard": false }),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_SuggestionsList, {
            "in-dashboard": false,
            "suggestion-clip-length": 120
          })
        ])
      ]),
      (!_ctx.embedded && !_ctx.offline)
        ? (_openBlock(), _createBlock(_component_ScreenBottomButton, {
            key: 0,
            icon: _ctx.bulbIcon,
            title: "Make Suggestion",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.router.push('/suggestions/suggestion/create')))
          }, null, 8, ["icon"]))
        : _createCommentVNode("", true)
    ], undefined, true),
    _: 1
  }))
}